import React, { Component } from 'react'
import SortableTree, {
  getNodeAtPath,
  addNodeUnderParent,
  removeNodeAtPath,
  changeNodeAtPath,
} from 'react-sortable-tree'
import Theme from 'react-sortable-tree-theme-minimal'
import CheckboxMUI from 'material-ui/Checkbox'
import TextFieldMUI from 'material-ui/TextField'
import ContentAdd from 'material-ui/svg-icons/content/add'
import 'whatwg-fetch'
import { FlatButton, FloatingActionButton } from 'material-ui'
import { Field } from 'redux-form'
import {
  List,
  Edit,
  DisabledInput,
  SimpleForm,
  EditButton,
  Datagrid,
  TextField,
  Filter,
  SelectInput,
  NumberInput,
} from 'admin-on-rest'
import { PackageAutoComplete, OfferAutoComplete, CountriesAutoComplete } from './components/autoComplete'
import { searchPackages } from './restClient'
import { numberMinValidation } from './utils/validation'

const sectionsFormatter = (v) => {
  try {
    JSON.parse(v)
  } catch (e) {
    return
  }

  return JSON.parse(v)
}

export class SectionsHiddenInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      actual: props.actual,
    }
  }

  componentWillReceiveProps(newProps) {
    this.props.input.onChange(newProps.actual)
    this.setState({ actual: newProps.actual })
  }

  render() {
    return (
      <div>
        <input name="sections" value={this.state.actual} type="hidden" />
      </div>
    )
  }
}

export class SectionsHidden extends Component {
  constructor(props) {
    super(props)

    this.state = {
      actual: props.actual,
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({ actual: newProps.actual })
  }
  render() {
    return (
      <Field
        name="sections"
        normalize={sectionsFormatter}
        actual={JSON.stringify(this.state.actual)}
        component={SectionsHiddenInput}
      />
    )
  }
}

function isPackageTreeNode(nodeData) {
  return nodeData.collapsed != null || nodeData.selected != null || nodeData.offer
}

function getPackageNodeData({ packages, packagesLayout = [] }) {
  return packages.map((id) => {
    const { collapsed, selected, offer, trending } =
      packagesLayout.find(({ packageIdentifier }) => packageIdentifier === id) || {}

    return {
      title: id,
      collapsed,
      selected,
      offer,
      trending,
    }
  })
}

export class Sections extends Component {
  constructor(props) {
    super(props)

    this.state = {
      treeData: props.record.sections.map((section) => {
        section.title = section.titleKey
        section.children = getPackageNodeData(section)
        return section
      }),
      sectionName: '',
      packageName: '',
    }
  }

  addSectionNode = (rowInfo) => {
    const { treeData } = this.state
    let { sectionName } = this.state
    sectionName = typeof sectionName === "string" ? sectionName.trim() : sectionName
    if (!sectionName) {
      return
    }
    let NEW_NODE = { title: sectionName, titleKey: sectionName }
    let { path } = rowInfo

    path.pop()
    let parentNode = getNodeAtPath({
      treeData: treeData,
      path: path,
      getNodeKey: ({ treeIndex }) => treeIndex,
      ignoreCollapsed: true,
    })
    let getNodeKey = ({ node: object, treeIndex: number }) => {
      return number
    }
    let parentKey = getNodeKey(parentNode)
    if (parentKey === -1) {
      parentKey = null
    }
    let newTree = addNodeUnderParent({
      treeData: treeData,
      newNode: NEW_NODE,
      expandParent: true,
      parentKey: parentKey,
      getNodeKey: ({ treeIndex }) => treeIndex,
    })
    const newTreeData = this.syncData(newTree.treeData)
    this.setState({ treeData: newTreeData, sectionName: '' })
  }

  addPackageNodeFactory = (rowInfo) => {
    return async (chosenRequest) => {
      await this.addPackageNode(rowInfo, chosenRequest)
      return true // clear input field
    }
  }

  addPackageNode = async (rowInfo, chosenRequest) => {
    const { countryCode, platform } = this.props.record
    const packageAboutToAdd = await searchPackages(chosenRequest, countryCode, platform)
    if (!packageAboutToAdd) {
      return
    }
    let NEW_NODE = {
      title: chosenRequest.productIdentifier,
      collapsed: rowInfo.node.collapsed,
      selected: rowInfo.node.selected,
      trending: rowInfo.node.trending,
    }
    let { path } = rowInfo

    let parentNode = getNodeAtPath({
      treeData: this.state.treeData,
      path: path,
      getNodeKey: ({ treeIndex }) => treeIndex,
      ignoreCollapsed: true,
    })
    let getNodeKey = ({ node: object, treeIndex: number }) => {
      return number
    }
    let parentKey = getNodeKey(parentNode)
    if (parentKey === -1) {
      parentKey = null
    }
    let newTree = addNodeUnderParent({
      treeData: this.state.treeData,
      newNode: NEW_NODE,
      expandParent: true,
      parentKey: parentKey,
      getNodeKey: ({ treeIndex }) => treeIndex,
    })
    const treeData = this.syncData(newTree.treeData)
    this.setState({ treeData })
  }

  updateNode = (rowInfo, putData) => {
    let { node, path } = rowInfo
    const newNode = { ...node, ...putData }
    let treeData = changeNodeAtPath({
      treeData: this.state.treeData,
      path: path, // You can use path from here
      newNode,
      getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
        return number
      },
      ignoreCollapsed: true,
    })

    treeData = this.syncData(treeData)
    this.setState({ treeData })
  }

  removeNode = (rowInfo) => {
    let { path } = rowInfo
    let treeData = removeNodeAtPath({
      treeData: this.state.treeData,
      path: path, // You can use path from here
      getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
        return number
      },
      ignoreCollapsed: true,
    })

    treeData = this.syncData(treeData)
    this.setState({ treeData })
  }

  updateTreeData = (treeData) => {
    treeData = this.syncData(treeData)
    this.setState({ treeData })
  }

  updateSectionName = (event) => {
    this.setState({
      sectionName: event.target.value,
    })
  }

  syncData = (data) => {
    data.forEach((section) => {
      section.packages = section.children ? section.children.map((child) => child.title) : []
      section.packagesLayout = section.children
        ? section.children.map(({ title, ...layout }) => ({ packageIdentifier: title, ...layout }))
        : []
    })

    return data
  }

  render() {
    return (
      <div>
        <TextFieldMUI
          name="newSection"
          onChange={(event) => this.updateSectionName(event)}
          hintText="Input Section Name"
          floatingLabelText="Section Name"
          value={this.state.sectionName}
        />
        <FloatingActionButton mini={true} onClick={(event) => this.addSectionNode({ node: {}, path: [0] })}>
          <ContentAdd />
        </FloatingActionButton>
        <SortableTree
          theme={Theme}
          maxDepth={2}
          treeData={this.state.treeData}
          onChange={this.updateTreeData}
          canDrop={({ nextPath, prevPath }) => nextPath.length === prevPath.length}
          generateNodeProps={(rowInfo) => {
            const { node, path, parentNode = false } = rowInfo
            const { collapsed = false, selected = false, trending = false } = node || {}
            const isSection = path.length === 1

            return {
              buttons: [
                isSection ? (
                  <PackageAutoComplete
                    key={`offer${rowInfo.treeIndex}${rowInfo.parentNode ? rowInfo.parentNode._id : ''}${rowInfo.node.offer || rowInfo.node._id}`}
                    {...this.props}
                    node={rowInfo}
                    onNewRequest={this.addPackageNodeFactory(rowInfo)}
                  />
                ) : null,
                ...(isPackageTreeNode(node) || parentNode
                  ? [
                      (
                        <div key="trending" className="trending-box">
                          <CheckboxMUI
                            checked={trending || false}
                            label="Trending"
                            onCheck={() => this.updateNode(rowInfo, { trending: !trending })}
                          />
                        </div>
                      ),
                      (<div key="switches">
                        <CheckboxMUI
                          checked={collapsed}
                          label="Collapsed"
                          onCheck={() => this.updateNode(rowInfo, { collapsed: !collapsed })}
                        />
                        <CheckboxMUI
                          checked={selected || false}
                          label="Selected"
                          onCheck={() => this.updateNode(rowInfo, { selected: !selected })}
                        />
                      </div>),
                      (<OfferAutoComplete
                        key={`offer${rowInfo.treeIndex}${rowInfo.parentNode ? rowInfo.parentNode._id : ''}${rowInfo.node.offer || rowInfo.node._id}`}
                        {...this.props}
                        node={node}
                        onNewRequest={(offer) => this.updateNode(rowInfo, { offer: offer._id })}
                        clearOffer={() => this.updateNode(rowInfo, { offer: undefined })}
                      />),
                    ]
                  : []),
                <FlatButton key="remove" onClick={() => this.removeNode(rowInfo)}>
                  Remove
                </FlatButton>,
              ],
              style: { height: '50px', width: '100%' },
            }
          }}
          isVirtualized={false}
        />
        <SectionsHidden actual={this.state.treeData} {...this.props} />
      </div>
    )
  }
}

const ShopFilter = (props) => (
  <Filter {...props}>
    <CountriesAutoComplete source='countryCode' label="Country" {...props} />
    <SelectInput
      label="Platform"
      source="platform"
      choices={[{ id: 'ios', name: 'iOs' }, { id: 'android', name: 'Android' }]}
    />
  </Filter>
)

export const ShopList = (props) => (
  <List {...props} filters={<ShopFilter />} perPage={40} sort={{ field: '_id', order: 'DESC' }}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField label="Country" source="country.name" />
      <TextField label="Platform" source="platform" />
      <EditButton />
    </Datagrid>
  </List>
)

const ShopTitle = ({ record }) => {
  return <span>For {record ? `"${record.country && record.country.name ? record.country.name : ''}" on "${record.platform}` : ''}</span>
}

export const ShopEdit = (props) => (
  <Edit title={<ShopTitle />} {...props}>
    <SimpleForm {...props}>
      <DisabledInput source="id" />
      <DisabledInput label="Country" source="country.name" />
      <DisabledInput label="Platform" source="platform" />
      <NumberInput validate={numberMinValidation} label="Base Price Private Question" source="privateBasePrice" />
      <NumberInput validate={numberMinValidation} label="Base Price Public Question" source="publicBasePrice" />
      <Sections {...props} />
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/shops.js